export { subscribeTicketAdapter } from './subscribe-ticket-res.adapter'
